(function () {
  const L = window.LAF || {};
  const S = L.strings || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* Keep the department bar just under the sticky header */
  const header = $('.section-header') || $('header.site');
  function setHeaderH() { if (header) document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px'); }
  setHeaderH();
  window.addEventListener('resize', setHeaderH);

  function formatMoney(cents) {
    const fmt = L.moneyFormat || '${{amount}}';
    const value = cents / 100;
    const withDelim = (n, d, t, s) => {
      const parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts.join(s);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelim(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelim(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelim(value, 0, '.', ',');
        default: return withDelim(value, 2, ',', '.');
      }
    });
  }
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* Aisle arrows */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.js-rail-scroll');
    if (!b) return;
    const rail = b.closest('.aisle').querySelector('.rail');
    rail.scrollBy({ left: Number(b.dataset.dir) * rail.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* Department filter chips (collection pages that use .js-depts) */
  $$('.js-depts').forEach((group) => {
    const grid = group.parentElement.querySelector('.js-grid');
    group.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-filter]');
      if (!btn) return;
      const f = btn.dataset.filter;
      $$('[data-filter]', group).forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
      $$('.tile', grid).forEach((card) => { card.hidden = f !== 'all' && card.dataset.type !== f; });
    });
  });

  /* ---------- Localized product names (titles are stored in one language) ---------- */
  const NAME_KEY = 'laf-names-' + document.documentElement.lang;
  let names = {};
  try { names = JSON.parse(sessionStorage.getItem(NAME_KEY) || '{}'); } catch (e) {}
  $$('[data-variant-id][data-name]').forEach((el) => { if (el.dataset.name) names[el.dataset.variantId] = el.dataset.name; });
  try { sessionStorage.setItem(NAME_KEY, JSON.stringify(names)); } catch (e) {}
  const displayName = (item) => names[String(item.variant_id)] || item.product_title;

  /* ---------- Cart state ---------- */
  let cartState = null;
  async function fetchCart() {
    const res = await fetch(L.routes.cart_js, { headers: { Accept: 'application/json' } });
    cartState = await res.json();
    return cartState;
  }
  async function post(url, body) {
    const res = await fetch(url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || S.error);
    }
    return res.json();
  }
  function lineFor(variantId) {
    if (!cartState) return null;
    return cartState.items.find((i) => String(i.variant_id) === String(variantId)) || null;
  }

  /* Tile controls: "+" turns into a − qty + stepper once the item is in the cart */
  function controlHTML(variantId, unit, qty) {
    if (!qty) return `<button class="add js-add" type="button" data-variant-id="${variantId}" data-unit="${unit}" aria-label="${esc(S.addOne)}">+</button>`;
    const shown = unit === 'lb' ? `${qty} lb` : qty;
    return `<div class="stepper"><button type="button" class="js-dec" data-variant-id="${variantId}" data-unit="${unit}" aria-label="${esc(S.removeOne)}">−</button><span>${shown}</span><button type="button" class="js-inc" data-variant-id="${variantId}" data-unit="${unit}" aria-label="${esc(S.addOne)}">+</button></div>`;
  }
  function syncTiles() {
    $$('.tile .ctl').forEach((ctl) => {
      const btn = ctl.querySelector('[data-variant-id]');
      if (!btn) return;
      const line = lineFor(btn.dataset.variantId);
      const qty = line ? line.quantity : 0;
      const current = ctl.querySelector('.stepper span');
      const want = qty ? (btn.dataset.unit === 'lb' ? `${qty} lb` : String(qty)) : null;
      if ((current ? current.textContent : null) !== want) ctl.innerHTML = controlHTML(btn.dataset.variantId, btn.dataset.unit || '', qty);
    });
  }
  function syncBar() {
    const bar = $('#CartBar');
    if (!bar || !cartState) return;
    const sum = $('#CartBarSum');
    if (sum && S.barSummary) sum.textContent = S.barSummary.replace('__COUNT__', cartState.item_count).replace('__TOTAL__', formatMoney(cartState.total_price));
    if (document.body.classList.contains('template-cart') || cartState.item_count === 0) bar.setAttribute('data-empty', '');
    else bar.removeAttribute('data-empty');
  }
  function renderDrawer() {
    const count = $('#CartCount');
    if (count) count.textContent = cartState.item_count;
    const lines = $('#CartLines');
    if (!lines) return;
    $('#CartSubtotal').textContent = formatMoney(cartState.total_price);
    $('#CartCheckout').disabled = cartState.item_count === 0;
    if (!cartState.items.length) { lines.innerHTML = `<p class="empty">${esc(S.empty)}</p>`; return; }
    lines.innerHTML = cartState.items.map((item, i) => {
      const img = item.image ? `<img src="${esc(item.image)}&width=120" alt="" loading="lazy">` : '🛒';
      const type = (item.product_type || '').toLowerCase().replace(/[^a-z0-9]+/g, '-');
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? ` · ${esc(item.variant_title)}` : '';
      const props = item.properties ? Object.entries(item.properties).filter(([k, v]) => v && k[0] !== '_').map(([k, v]) => `<div class="sub">${esc(k)}: ${esc(v)}</div>`).join('') : '';
      return `<div class="line">
        <a class="em t-${type}" href="${esc(item.url)}" tabindex="-1" aria-hidden="true">${img}</a>
        <div><a class="nm" href="${esc(item.url)}">${esc(displayName(item))}</a>${props}<div class="sub">${formatMoney(item.final_price)}${variant} · ${formatMoney(item.final_line_price)}</div></div>
        <div class="qty"><button type="button" data-line="${i + 1}" data-q="${item.quantity - 1}" aria-label="${esc(S.removeOne)}">−</button><span>${item.quantity}</span><button type="button" data-line="${i + 1}" data-q="${item.quantity + 1}" aria-label="${esc(S.addOne)}">+</button></div>
      </div>`;
    }).join('');
  }
  function syncAll() { renderDrawer(); syncTiles(); syncBar(); }

  async function setQty(variantId, qty) {
    const line = lineFor(variantId);
    if (line) await post(L.routes.cart_change_url, { id: line.key, quantity: Math.max(0, qty) });
    else if (qty > 0) await post(L.routes.cart_add_url, { items: [{ id: Number(variantId), quantity: qty }] });
    await fetchCart();
    syncAll();
  }

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('.js-add, .js-inc, .js-dec');
    if (!b) return;
    const id = b.dataset.variantId;
    const line = lineFor(id);
    const qty = line ? line.quantity : 0;
    const next = b.classList.contains('js-dec') ? qty - 1 : qty + 1;
    b.disabled = true;
    try { await setQty(id, next); } catch (err) { b.textContent = '!'; b.title = err.message; }
    b.disabled = false;
  });

  /* Drawer */
  const drawer = $('#CartDrawer');
  const scrim = $('#CartScrim');
  function openDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    scrim.hidden = !open;
    document.body.classList.toggle('drawer-open', open);
    if (open) drawer.focus();
  }
  async function showDrawer(e) {
    if (document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    await fetchCart();
    syncAll();
    openDrawer(true);
  }
  if (drawer) {
    $('#CartOpen')?.addEventListener('click', showDrawer);
    $('#CartBarOpen')?.addEventListener('click', showDrawer);
    $('#CartClose').addEventListener('click', () => openDrawer(false));
    scrim.addEventListener('click', () => openDrawer(false));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') openDrawer(false); });
    drawer.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-line]');
      if (!b) return;
      await post(L.routes.cart_change_url, { line: Number(b.dataset.line), quantity: Math.max(0, Number(b.dataset.q)) });
      await fetchCart();
      syncAll();
    });
  }

  if ($('.tile .ctl') || $('#CartBar')) fetchCart().then(syncAll).catch(() => {});

  /* Product page: variant selection + add to cart */
  const form = $('.js-product-form');
  if (form) {
    const variants = JSON.parse(($('.js-variants') || {}).textContent || '[]');
    const idInput = $('.js-variant-id', form);
    const submit = $('.js-submit', form);
    const price = $('.js-price');
    const selects = $$('.js-option', form);
    const unitHTML = price ? (price.querySelector('.u') || {}).outerHTML || '' : '';
    submit.dataset.addLabel = submit.textContent.trim();
    selects.forEach((sel) => sel.addEventListener('change', () => {
      const opts = selects.map((s) => s.value);
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      if (!v) return;
      idInput.value = v.id;
      submit.disabled = !v.available;
      submit.textContent = v.available ? submit.dataset.addLabel : S.soldOut;
      if (price) price.innerHTML = formatMoney(v.price) + unitHTML + (v.compare_at_price > v.price ? ` <s class="was">${formatMoney(v.compare_at_price)}</s>` : '');
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }));
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const choice = $('.js-required-choice', form);
      if (choice && !choice.value.trim()) {
        choice.closest('.choice-field').classList.add('invalid');
        choice.setCustomValidity(choice.dataset.msg || '');
        choice.reportValidity();
        choice.focus();
        return;
      }
      if (choice) { choice.setCustomValidity(''); choice.closest('.choice-field').classList.remove('invalid'); }
      submit.disabled = true;
      try {
        const properties = {};
        $$('[name^="properties["]', form).forEach((el) => { const k = el.name.slice(11, -1); if (el.value.trim()) properties[k] = el.value.trim(); });
        const item = { id: Number(idInput.value), quantity: Number($('[name="quantity"]', form).value) || 1 };
        if (Object.keys(properties).length) item.properties = properties;
        await post(L.routes.cart_add_url, { items: [item] });
        await fetchCart();
        syncAll();
        openDrawer(true);
      } catch (err) {
        submit.textContent = err.message;
        setTimeout(() => { submit.textContent = submit.dataset.addLabel; }, 2500);
      }
      submit.disabled = false;
    });
  }
})();
